let utils = {};

// 成功提示
utils.success = function (vm, msg) {
    msg = msg || '成功！';
    mui.toast(msg, { duration: 1500, type: 'div' });

};

// 失败提示
utils.error = function (vm, msg) {
    if (msg == '充电抢未连接，请检查充电枪是否以及插紧') {
        msg = '充电桩未连接，请检查充电枪是否已经插紧';
    }
    msg = msg || '失败！';

    var mode = vm.$C.testMode;
    // h5
    if (mode == 'h5') {
        mui.toast(msg, { duration: 1500, type: 'div' });
    } else if (mode == 'app') {
        var u = navigator.userAgent;
        var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //安卓端
        var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //IOS端
        if (isAndroid) {
            jsBridge && jsBridge.showErrorBanner(msg);
        }
        if (isIos) {
            window.webkit.messageHandlers.showErrorBanner.postMessage(msg);
        }

    }
};

// 警告提示
utils.warning = function (vm, msg) {
    msg = msg || '警告！';
    vm.$Message.warning(msg);
};

// 非空判断
utils.notEmpty = function (o) {
    if (o == undefined || o == '' || o == null) {
        return false;
    }
    return true;
};
utils.isEmpty = function (o) {
    if (o == undefined || o == '' || o == null) {
        return true;
    }
    return false;
};

// 排序参数
utils.compare = function (property) {
    return function (a, b) {
        var value1 = a[property];
        var value2 = b[property];
        return value1 - value2;
    };
};


// 文件
utils.saveExcelFile = function (data) {
    var fileName = data.fileName;
    // 判断空
    if (utils.isEmpty(fileName)) return;

    var bin = atob(data.base64.replace(/\s/g, ''));
    var buffer = new Uint8Array(bin.length);
    for (var i = 0; i < bin.length; i++) {
        buffer[i] = bin.charCodeAt(i);
    }

    var blob = new Blob([buffer.buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // 输出文件
    if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, fileName);
    } else {
        var a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.target = '_blank';
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(a.href);
    }
};

export default utils;





// WEBPACK FOOTER //
// ./src/utils/utils.js